import { Injectable } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidationsService {
  static getErrorMessage(
    control: AbstractControl | NgModel,
    fieldName: string,
    fieldLabel: string
  ): string {
    if (control.errors?.['required']) {
      return `${fieldLabel} is required.`;
    }
    if (control.errors?.['notAvailable']) {
      return `${fieldLabel} is not existing!`
    }
    if (control.errors?.['email']) {
      return `Enter a valid email address.`;
    }
    if (control.errors?.['pattern']) {
      if (fieldName === 'phoneNumber' || fieldName === 'businessPhoneNumber') {
        return `Phone number must be exactly 10 digits.`;
      }
      if (fieldName === 'taxId') {
        return `Tax Id must be exactly 10 digits.`;
      }
      if (
        fieldName === 'firstName' ||
        fieldName === 'lastName' ||
        fieldName === 'name' ||
        fieldName === 'roleName' ||
        fieldName === 'businessName' ||
        fieldName === 'campaignName'
      ) {
        return `${fieldLabel} can only contain letters.`;
      }
      if (fieldName === 'city' || fieldName === 'state') {
        return `${fieldLabel} can only contain letters and spaces.`;
      }
      if (fieldName === 'zip') {
        return `ZIP code must be exactly 5 digits.`;
      }
      if (fieldName === 'organisationName' || fieldName === 'groupName') {
        return `${fieldLabel} contains only alphanumeric value.`;
      }
      if (fieldName === 'address' || fieldName === 'address2') {
        return `${fieldLabel} contains only alphanumeric and symbols value`;
      }
      if (fieldName.toLowerCase().includes('password')) {
        return `${fieldLabel} contains at least One Capital Letter, One Numeric and One Special Character @$!%.*?&`;
      }
      if (
        fieldName === 'email' ||
        fieldName === 'businessEmailAddress' ||
        fieldName === 'businessEmail' ||
        fieldName === 'emailAddress' ||
        fieldName === 'businessEmail'
      ) {
        return `Enter a Valid Email Address.`;
      }
    }
    if (control.errors?.['minlength']) {
      return `${fieldLabel} must be at least ${control.errors['minlength'].requiredLength} characters long.`;
    }
    if (control.errors?.['maxlength']) {
      return `${fieldLabel} cannot be more than ${control.errors['maxlength'].requiredLength} characters long.`;
    }
    if (control.errors?.['atLeastOnePhoneNumberFilled']) {
      return `At Least one phone number is required`;
    }
    // Add other validation types as needed
    return '';
  }
}
